import ApiBase from "Services/Api/ApiBase";

export default new class extends ApiBase {
    route = '/admin/human-resources/holiday/dashboard';
};
